import axios from 'axios'
import {
  SupplierModel,
  LegalRepresentativeModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  ResponseObjectURL,
  EquipmentSupplierModel,
} from '../model'
import {TableResumen} from '../../central/model'
import {ID} from '../../../../../_metronic/helpers'
const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL
export function getSupplier(dto: SupplierModel, page: number) {
  return axios.post<ResponseObjectPaginated<SupplierModel[]>>(
    `${BASEURL}/supplier/getAll/${page}`,
    dto,
  )
}
export function getSupplierById(dto: string | undefined) {
  return axios.get<ResponseObject<SupplierModel>>(
    `${BASEURL}/supplier/getInformationById?pointId=${dto}`,
  )
}

export function createSupplier(dto: SupplierModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/supplier/createSupplier`, dto)
}

export function deleteSupplier(supplierId: ID) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/supplier/deleteSupplier?id=${supplierId}`)
}

export function updateSupplier(dto: SupplierModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/supplier/updateSupplier`, dto)
}

// INICIO ---- SERVICIOS MASIVE

// export function downloadTemplateSupplier() {
//   return axios.post<ResponseObjectURL>(`${BASEURL}/supplier/downloadTemplateBulkLoad`)
// }

export function downloadTemplateSupplier() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/supplier/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadMasiveSupplier(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(`${BASEURL}/supplier/bulkLoad`, dto)
}

// FIN ---- SERVICIOS MASIVE

export function getLegalRepresentative(dto: LegalRepresentativeModel, page: number) {
  return axios.post<ResponseObjectPaginated<LegalRepresentativeModel[]>>(
    `${BASEURL}/supplier/getAllLegalRepresentative/${page}`,
    dto,
  )
}

export function createLegalRepresentative(dto: LegalRepresentativeModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/supplier/createLegalRepresentative`, dto)
}

export function deleteLegalRepresentative(id: ID) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/supplier/deleteLegalRepresentative?id=${id}`)
}

export function updateLegalRepresentative(dto: LegalRepresentativeModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/supplier/updateLegalRepresentative`, dto)
}

///

export function getEquipSupplier(dto: EquipmentSupplierModel, page: number) {
  return axios.post<ResponseObjectPaginated<EquipmentSupplierModel[]>>(
    `${BASEURL}/equip/getAll/${page}`,
    dto,
  )
}

export function createEquipSupplier(dto: EquipmentSupplierModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/equip/createEquip`, dto)
}

export function deleteEquipSupplier(id: ID) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/equip/deleteEquip?id=${id}`)
}

export function updateEquipSupplier(dto: EquipmentSupplierModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/equip/updateEquip`, dto)
}
